import stylesheet from './gruvboxDark.css.js'

export default {
  themeName: 'Gruvbox Dark',
  palette: {
    primary: {
      main: '#8ec07c',
    },
    secondary: {
      main: '#3c3836',
      contrastText: '#ebdbb2',
    },
    type: 'dark',
    background: {
      default: '#282828',
    },
    text: {
      primary: '#ebdbb2',
      secondary: '#a89984',
    },
  },
  overrides: {
    MuiPaper: {
      root: {
        color: '#ebdbb2',
        backgroundColor: '#3c3836',
      },
    },
    MuiSnackbarContent: {
      root: {
        color: '#3c3836',
        backgroundColor: '#a89984',
      },
      message: {
        color: '#3c3836',
        backgroundColor: '#a89984',
      },
    },
    MuiTypography: {
      root: {
        color: '#ebdbb2',
      },
      colorTextSecondary: {
        color: '#a89984',
      },
    },
    MuiButton: {
      textPrimary: {
        color: '#458588',
      },
      textSecondary: {
        color: '#ebdbb2',
      },
    },
    MuiIconButton: {
      root: {
        color: '#ebdbb2',
      },
    },
    MuiListItemIcon: {
      root: {
        color: '#ebdbb2',
      },
    },
    MuiListItemText: {
      primary: {
        color: '#ebdbb2',
      },
      secondary: {
        color: '#a89984',
      },
    },
    MuiChip: {
      clickable: {
        background: '#49483e',
      },
    },
    MuiFormGroup: {
      root: {
        color: '#ebdbb2',
      },
    },
    MuiFormHelperText: {
      root: {
        color: '#ebdbb2',
      },
      error: {
        color: '#cc241d',
      },
    },
    MuiTableHead: {
      root: {
        color: '#ebdbb2',
        background: '#3c3836 !important',
      },
    },
    MuiTableCell: {
      root: {
        color: '#ebdbb2',
        background: '#3c3836 !important',
      },
      head: {
        color: '#ebdbb2',
        background: '#3c3836 !important',
      },
    },
    NDLogin: {
      systemNameLink: {
        color: '#8ec07c',
      },
      icon: {},
      welcome: {
        color: '#ebdbb2',
      },
      card: {
        minWidth: 300,
        background: '#3c3836',
      },
      avatar: {},
      button: {
        boxShadow: '3px 3px 5px #3c3836',
      },
    },
    MuiSwitch: {
      colorSecondary: {
        '&$checked': {
          color: '#458588',
        },
        '&$checked + $track': {
          backgroundColor: '#458588',
        },
      },
    },
    NDMobileArtistDetails: {
      bgContainer: {
        background:
          'linear-gradient(to bottom, rgba(52 52 52 / 72%), rgb(48 48 48))!important',
      },
    },
    NDAlbumGridView: {
      albumName: {
        marginTop: '0.5rem',
        fontWeight: 700,
        textTransform: 'none',
        color: '#ebdbb2',
      },
      albumSubtitle: {
        color: '#a89984',
      },
    },
  },
  player: {
    theme: 'dark',
    stylesheet,
  },
}
